const home = {
  hello: "Hello",
  how: "Here's how your company is doing",
  lastTransUp: "Last transaction uploaded",
  addTrans: "Add Transactions",
  viewAll: "View all",
  title: {
    yourDD: "Reporting calendar",
    news: "News",
    payInfo: "Payment info",
    vatRet: "VAT returns",
    salesTaxRet: "Sales tax returns",
    eprRet: "EPR returns",
  },
  warning: "Warning",
  overPlan: "Your tariff plan is over",
  dot: ".",
  selectPlan: "select plan",
  canCont: "You can continue using Lappa software when you subscribe",
  fillVR: "Fill Return",
  balance: "Balance",
  deposit: "deposit",
  addDeposit: "Add deposit",
  yVAT: "Yearly",
  qVAT: "Quarterly",
  mVAT: "Monthly",
  yEPR: "Yearly",
  qEPR: "Quarterly",
  mEPR: "Monthly",
  ySalexTax: "Yearly Sales tax",
  qSalesTax: "Quarterly Sales tax",
  mSalesTax: "Monthly Sales tax",
  statuses: {
    new: "new",
    pending: "pending",
    submitted: "submitted",
    autoSubmitted: "auto-submitted",
    declined: "declined",
    draft: "draft",
    void: "void",
    autoSub: "auto-submitted",
  },
  noDataYet: "Nothing to show here yet",
  addStoreToSeeData: "Add store to see data",
  addStore: "Add store",
  noArticlesYet: "No articles yet",
  readMore: "Read more",
  addEprReturnsToSeeData: "Add EPR returns to see data",
  addEprReturn: "Add EPR return",
  addVatReturnsToSeeData: "Add VAT returns to see data",
  addVatReturns: "Add VAT returns",
  addTaxReturnsToSeeData: "Add TAX returns to see data",
  addTaxReturns: "Add TAX returns",
  deemedVatTitle: "Deemed VAT in thousand EUR",
  deemedImport: "Deemed Import",
  deemedEur: "Deemed EUR",
  noData: "No data",
  thresholdUSA: "Threshold USA",
  thresholdEU: "Threshold EU",
  transactionsByCountry: "Transactions by country",
  remittedSalesTaxByStates: "Remitted sales tax by states",
  noSingleSale: "There is not a single sale",
  partnerLevel: "Your partner level is",
  giveYou: "Give you",
  toAllServices: "to all services",
  clientsOrReferrals: "clients or referrals for achieve next level",
  youNeed: "You need",
  noClients: "You don't have any client.",
  subscriptionPlan: "Subscription Plan:",
}

export default home;
